import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://lmsbxodfafkdbueycxnf.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxtc2J4b2RmYWZrZGJ1ZXljeG5mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2NjYwOTQsImV4cCI6MjA3MzI0MjA5NH0.N98hydS7a5_jPORNXw6lUd4ACUUVvU1-lAyR5Q3L9ec'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
